import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getOrientacaoSexual, cadastrarOrientacaoSexual, alterarOrientacaoSexual, excluirOrientacaoSexual } from '../../../api';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
var OrientacoesSexuaisEditar = function () {
    var services = {
        getItem: getOrientacaoSexual,
        cadastrarItem: cadastrarOrientacaoSexual,
        alterarItem: alterarOrientacaoSexual,
        excluirItem: excluirOrientacaoSexual,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.ORIENTACOES_SEXUAIS, paginaPermissao: FUNCIONALIDADES.ORIENTACOES_SEXUAIS, rota: ROUTES.ORIENTACOES_SEXUAIS, services: services });
};
export default OrientacoesSexuaisEditar;
